
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmTabs } from "@afe/amui/src/components/Tabs";
import { AmIcon } from "@afe/amui/src/components/Icon";
import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import HeaderBox from "./HeaderBox.vue";

const searchNode = (nodes: any[], search: string) => {
  const result: any[] = [];

  nodes.forEach(node => {
    if (node.instruments) {
      result.push(
        ...node.instruments.filter(
          ({ name, desc }: { name: string; desc: string }) =>
            name.toLowerCase().indexOf(search) > -1 ||
            desc.toLowerCase().indexOf(search) > -1
        )
      );

      const search_str = search.toLowerCase();

      if (
        "dax 4 dax40 dax 40 dax30 dax 3 germany germany40 germany 40 de30 de40 ger30 ger40 fdax fdxm gdaxi german stock index deutsche aktienindex de0008469008".includes(
          search_str
        )
      ) {
        result.push(
          ...node.instruments.filter(
            ({ name }: { name: string }) =>
              name == "GERMANY40" || name == "GER40_"
          )
        );
      }

      if (
        "stoxx euro stoxx50 eu50 eu stocks europe 50 euro 50 sx5e estx eu0009658145".includes(
          search_str
        )
      ) {
        result.push(
          ...node.instruments.filter(
            ({ name }: { name: string }) =>
              name == "STXE50" || name == "STXE50-SB"
          )
        );
      }

      if (
        "mdax german mid cap midcap 50 germany 50 de0008467416".includes(
          search_str
        )
      ) {
        result.push(
          ...node.instruments.filter(
            ({ name }: { name: string }) => name == "GER.MID50"
          )
        );
      }

      if (
        "tecdax de tech tec30 germany tech german tec de0007203275".includes(
          search_str
        )
      ) {
        result.push(
          ...node.instruments.filter(
            ({ name }: { name: string }) => name == "GER.TEC30"
          )
        );
      }
    }
    if (node.subtype) {
      result.push(...searchNode(node.subtype, search));
    }
  });

  return result;
};

const sortByName = (a: { name: string }, b: { name: string }) =>
  a.name.localeCompare(b.name);

@Component({
  components: { AmTypography, AmTabs, AmIcon, HeaderBox }
})
export default class extends Vue {
  @Prop(Object) readonly instruments!: any;
  @Prop(String) readonly path!: string;
  @Prop(String) readonly search!: string;
  @Prop(Boolean) readonly hasSortType!: boolean;
  @Prop(String) readonly sortType!: string;
  @Prop(Object) readonly messages!: any;
  @Prop(Function) readonly groupUrl!: any;
  @Prop(Function) readonly groupPath!: any;

  get list() {
    if (this.search.length >= 2) {
      return uniqBy(
        searchNode(this.flatList, this.search.toLowerCase()),
        "id"
      ).sort(sortByName);
    }

    let list = get(this.instruments, this.path).slice();

    if (this.hasSortType) {
      list = list.filter(({ is_filter }: any) => {
        if (this.sortType === "byExchange") {
          return is_filter === null;
        } else {
          return is_filter !== null;
        }
      });
    }

    if (this.path === "CFD") {
      return list;
    }

    return list.sort(sortByName);
  }

  get flatList() {
    const listAll: any[] = [];

    Object.keys(this.instruments).map(tabKey => {
      listAll.push(...this.instruments[tabKey]);
    });

    return listAll;
  }

  onExpandGroup(groupId: number) {
    const path = this.groupPath(groupId);

    if (path) {
      this.$emit("change", path);
    }
  }

  getInstrumentLink(slug: string) {
    return this.messages.linkToInstrument.replace("{slug}", slug);
  }

  onInstrument(slug: string) {
    window.location.assign(this.getInstrumentLink(slug));
  }
}
